module.exports = __webpack_public_path__ + "img/mgh-otemachi-sp.2642559d.jpg";